import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
    filter
      .options.list('global', 'Global', GLOBAL_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
  ], [])
}

const TYPE_OPTIONS = [
  { value: 'ip-country', label: 'IP Country' },
  { value: 'not-ip-country', label: 'Not IP Country' },
  { value: 'domain', label: 'Domain' },
  { value: 'email', label: 'e-mail' },
  { value: 'phone', label: 'Phone number' },
  { value: 'ip', label: 'IP' },
]

const GLOBAL_OPTIONS = [
  { label: 'True', value: 'true' },
  { label: 'False', value: '{"$or":[null,false]}' },
]
